// Copyright (c) Jim Garvin (http://github.com/coderifous), 2008.
// Dual licensed under the GPL (http://dev.jquery.com/browser/trunk/jquery/GPL-LICENSE.txt) and MIT (http://dev.jquery.com/browser/trunk/jquery/MIT-LICENSE.txt) licenses.
// Written by Jim Garvin (@coderifous) for use on LMGTFY.com.
// http://github.com/coderifous/jquery-localize
// Based off of Keith Wood's Localisation jQuery plugin.
// http://keith-wood.name/localisation.html

(function($) {
    $.localize = function(pkg, options) {
        var $wrappedSet = this;
        var intermediateLangData = {};
        options = options || {};

        function loadLanguage(pkg, lang, level) {
            level = level || 1;
            var file;
            if (options && options.loadBase && level === 1) {
                intermediateLangData = {};
                file = pkg + '.json';
                jsonCall(file, pkg, lang, level);
            }
            else if (level === 1) {
                intermediateLangData = {};
                loadLanguage(pkg, lang, 2);
            }
            else if (level === 2 && lang.length >= 2) {
                file = pkg + '_' + lang.substring(0, 2) + '.json';
                jsonCall(file, pkg, lang, level);
            }
            else if (level === 3 && lang.length >= 5) {
                file = pkg + '_' + lang.substring(0, 5) + '.json';
                jsonCall(file, pkg, lang, level);
            }
        }

        function jsonCall(file, pkg, lang, level) {
            if (options.pathPrefix) file = options.pathPrefix + "/" + file;
            // we skip already tried and failed files
            if (!$.localize.nonExisting[file]) {
                $.ajax({
                    url: file,
                    method: 'GET',
                    dataType: 'json',
                    data: null,
                    async: false,
                    timeout: (options && options.timeout ? options.timeout : 500),
                    success: function(d) {
                        $.extend(intermediateLangData, d);
                        notifyDelegateLanguageLoaded(intermediateLangData);
                        loadLanguage(pkg, lang, level + 1);
                    },
                    error: function(req, status, error) {
                        window.console.log("LANG:error: " + req.status + " : " + req.statusText + ":" + req.responseText);
                        $.localize.nonExisting[file] = true;
                    }
                });
            }
        }

        function defaultCallback(data) {
            var elem, key;

            $.localize.data[pkg] = data;
            var keys, matched, value;
            $wrappedSet.each(function() {
                elem = $(this);
                matched = elem.attr("rel").match(/localize\[(.*?)\]/);
                if (matched && matched[1]) {
                    key = matched[1];
                    value = valueForKey(key);
                    if (value) {
                        if (elem.attr('tagName') === "INPUT") {
                            elem.val(value);
                        } else {
                            elem.html(value);
                        }
                    }
                }
            });
        }

        function notifyDelegateLanguageLoaded(data) {
            if (options.callback) {
                // pass the defaultCallback so it can be used in addition to some custom behavior
                options.callback(data, defaultCallback);
            }
            else {
                defaultCallback(data);
            }
        }

        function valueForKey(key) {
            var keys = key.split(/\./);
            var value = $.localize.data[pkg];
            while (keys.length > 0) {
                if (value) {
                    value = value[keys.shift()];
                } else {
                    return null;
                }
            }
            return value;
        }

        function regexify(string_or_regex_or_array) {
            if (typeof(string_or_regex_or_array) === "string") {
                return "^" + string_or_regex_or_array + "$";
            }
            else if (string_or_regex_or_array.length) {
                var matchers = [];
                var x = string_or_regex_or_array.length;
                while (x--) {
                    matchers.push(regexify(string_or_regex_or_array[x]));
                }
                return matchers.join("|");
            }
            else {
                return string_or_regex_or_array;
            }
        }

        var lang = normaliseLang(options && options.language ? options.language : $.defaultLanguage);

        if (options.skipLanguage && lang.match(regexify(options.skipLanguage))) return;
        if ($.localize.data[pkg]) {
            notifyDelegateLanguageLoaded($.localize.data[pkg]);
        } else {
            loadLanguage(pkg, lang, 1);
        }

        return {
            translateString: function(key) {
                return valueForKey(key);
            }
        };
    };

    $.fn.localize = $.localize;

    // Storage for retrieved data
    $.localize.data = {};

    // Storage for non-existing urls
    $.localize.nonExisting = {};

    // Retrieve the default language set for the browser.
    $.defaultLanguage = normaliseLang(navigator.language
        ? navigator.language       // Mozilla
        : navigator.userLanguage   // IE
    );

    // Ensure language code is in the format aa-AA.
    function normaliseLang(lang) {
        lang = lang.replace(/_/, '-').toLowerCase();
        if (lang.length > 3) {
            lang = lang.substring(0, 3) + lang.substring(3).toUpperCase();
        }
        return lang;
    }
})(jQuery);
